<template>
  <div class="prompt-container" v-click-outside="onClosePrompt">
    <div class="prompt-header">{{title}}</div>
    <div class="prompt-body">
      <slot></slot>
      <!--      <input class="prompt-input" v-model="promptValue" />-->
      <div v-if="warning" class="warning-container">
        <div class="warning-title">{{ $t('camstudy.promptModal.warningTitle') }}</div>
        <div class="warning-message">{{ $t('camstudy.promptModal.warningMessage') }}</div>
      </div>
    </div>
    <div class="select-footer">
      <button class="select-footer-button select-cancel" @click="onClosePrompt">{{button[0]}}</button>
      <button class="select-footer-button select-save" @click="onNextAct">{{button[1]}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CamstudyPromptModal',
  props: {
    warning: {
      type: Boolean,
      default: true,
    },
    button: {
      type: Array,
      default() {
        return [this.$t('common.cancel'), this.$t('common.confirm')]
      }
    },
    title: {
      type: String,
      default: '',
    }
  },
  data(){
    return {
      promptValue: '',
    }
  },
  methods: {
    onClosePrompt(){
      this.$emit('onClosePrompt');
    },
    onNextAct(){
      this.$emit('onNextAct', this.promptValue);
    }
  }
}
</script>

<style scoped lang="scss">
[grm-device-mobile]{
  .prompt-container{
    @media(orientation: portrait){
      width: calc(100vw - 16px);
      bottom: 8px;
      left: 8px;
    }
    @media(orientation: landscape){
      width: 360px;
      bottom: 8px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
html:not([grm-device-mobile]) .prompt-container{
  width: 360px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.prompt-container {
  position: fixed;
  z-index: 999;
  border-radius: 12px;
  overflow: hidden;
  background: #313131;
  color: #FFF;

  .prompt-header {
    width: 100%;
    text-align: center;
    height: 44px;
    padding: 10px 20px;
    font-size: 14px;
  }
  .prompt-body {
    padding: 12px 20px 24px 20px;
    .prompt-input{
      display: block;
      border-radius: 6px;
      border: 1px solid #393939;
      background: #141414;
      outline: transparent;
      height: 33px;
      padding: 6px 12px;

      color: #FFF;
      font-size: 14px;
      line-height: 150%;
    }
  }
  .warning-container{
    margin-top: 24px;
  }
  .warning-title{
    font-weight: 700;
    font-size: 12px;
    line-height: 150%;
    color: #FF5353;
    padding-left: 22px;
    background: url('~@/assets/images/camstudy/warning_declaration.svg') no-repeat center left;
  }
  .warning-message{
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #FF5353;
    margin-top: 6px;
  }
  .select-footer{
    width: 100%;
    display: flex;
    .select-footer-button{
      width: 100%;
      display: flex;
      padding: 15px 0 14px;
      justify-content: center;
      align-items: center;
      border-top: 0.333px solid rgba(255, 255, 255, 0.20);

      &.select-cancel{
        color: #999;
        font-size: 14px;
        line-height: 150%;
      }
      &.select-save{
        color: #FFF;
        font-size: 14px;
        font-weight: 700;
        line-height: 150%;
      }
    }
  }
}
</style>